import React from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useGetOAuth2AppByClientIdQuery } from '../../../store/auth/auth'
import { Col, Container, Row, Spinner } from 'react-bootstrap'
import { OAuth2AppsRow } from './Components/OAuth2AppsRow'
import { OAuth2AppsManagementTabs } from './OAuth2AppsManagementTabs'
import { Navigate, useParams } from 'react-router-dom'

export const OAuth2AppsManagement: React.FC = () => {
  const { appId } = useParams<{ appId: string }>() as { appId: string }
  const accountId = useAppSelector(selectAccountId)
  const { data: oAuth2AppData, isLoading: oAuth2AppIsLoading } = useGetOAuth2AppByClientIdQuery({ accountId: accountId, clientId: appId })

  if (oAuth2AppIsLoading) {
    return (
      <div className='d-flex align-items-center justify-content-center'>
        <Spinner />
      </div>
    )
  }
  if (!oAuth2AppData) {
    return <Navigate to='/account/integration-settings/oauth2apps' replace />
  }
  return (
    <div className='full-size-content'>
      <Container fluid>
        <Row className='mb-9'>
          <OAuth2AppsRow oAuth2App={oAuth2AppData} />
        </Row>
        <Row>
          <Col lg={12}>
            <OAuth2AppsManagementTabs oAuth2App={oAuth2AppData} />
          </Col>
        </Row>
      </Container>
    </div>
  )
}
